import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective, ButtonLabel } from 'primeng/button';

@Component({
  selector: 'au-forgot-password-success',
  templateUrl: './forgot-password-success.component.html',
  styleUrls: ['./forgot-password-success.component.scss'],
  imports: [ButtonDirective, RouterLink, ButtonLabel],
})
export class ForgotPasswordSuccessComponent {
  mercuryLogoPath = '../../assets/images/logo-original.svg';
}
